<template>
    <div class="huiyu">
        <div class="first">
            <div class="content">
                <div class="text">
                    <p>
                        <span>慧舆</span><span>定制化舆情跟踪系统</span>
                    </p>
                    <p>
                       慧舆定制化舆情跟踪系统用于实时从大量的财经门户，论坛，微博，微信公众号，杂志，报刊等抓取公司相关的信息，为每个客户进行个性化定制，推送他们所关注的公司，债券等的信息。
                    </p>
                </div>
                <img src="../assets/huiyu-back-cp.png"
     srcset="../assets/huiyu-back-cp@2x.png 2x,
             ../assets/huiyu-back-cp@3x.png 3x" class="imgOne">

            </div>
        </div>
        
           
        <div class="three">
            <div class="content">
                <div class="three-title">
                    <p>专注解决行业痛点</p>
                    <p>利用自然语言处理、爬虫、分词等多种技术，从海量数据中筛选出关注的信息，信息可视化展示</p>
                </div>
                <div class="three-content-two">
                    <div class="content-icon">
                        <img src="../assets/huiyu-back-one.png"
        srcset="../assets/huiyu-back-one@2x.png 2x,
                ../assets/huiyu-back-one@3x.png 3x">
                        <p>
                            新闻数据的采集存储板块
                        </p>
                        <p>
                            爬虫、数据清洗、情感分析、主体识别、数据存储等。
                        </p>
                    </div>
                    <div class="content-icon">
                        <img src="../assets/huiyu-back-two.png"
        srcset="../assets/huiyu-back-two@2x.png 2x,
                ../assets/huiyu-back-two@3x.png 3x">
                        <p>
                            个性化舆情定制
                        </p>
                        <p>
                           分词、基于BM25F的相关性打分等。 
                        </p>
                    </div>
                    <div class="content-icon">
                        <img src="../assets/huiyu-back-three.png"
        srcset="../assets/huiyu-back-three@2x.png 2x,
                ../assets/huiyu-back-three@3x.png 3x" class="special">
                        <p>
                            热点舆情追踪
                        </p>
                        <p>
                            分词、打热度分、LSI、Kmeans聚类等。
                        </p>
                    </div>
                
                </div>
                
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'huiyu'
}
</script>

<style lang="scss">
.huiyu{
    min-width: 1000px;
    .first{
        min-height: 623px;
        margin-bottom: 132px;
        background: url("../assets/huiyu-back-first.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/huiyu-back-first@2x.jpg") no-repeat center/cover;
        }
        @media only screen and (min--moz-device-pixel-ratio: 3),

        only screen and (-o-min-device-pixel-ratio: 3/1),

        only screen and (-webkit-min-device-pixel-ratio: 3),

        only screen and (min-device-pixel-ratio: 3){
            background: url("../assets/huiyu-back-first@3x.jpg") no-repeat center/cover;
        }

        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            padding:1px;
            position: relative;
            .text{
                width: 629px;
                margin: 0 auto;
                margin-top: 95px;
                text-align: center;
                p:nth-child(1){
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 1.5;
                    span:nth-child(1){
                        color:#fcc617
                    }
                }
                p:nth-child(2){
                    font-size: 14px;
                    line-height: 1.86;
                }
            }
            img.imgOne{
                position: absolute;
                left: 128px;
                top: 265px;
            }
        }
    }
   
    .three{
        width: 100%;
        overflow: hidden;
        .content{
           width: 1000px;
           margin: 75px auto;
           .three-title{
               width: 630px;
               height: 85px;
               margin: 0 auto;
               text-align: center;
               margin-bottom: 42px;
               p:nth-child(1){
                   color: #064ec1;
                   font-size: 20px;
                   line-height: 40px;
               }
               p:nth-child(2){
                   color: #333;
                   font-size: 14px;
                   line-height: 24px;
               }
           }
           .three-content-two{
               width: 850px;
               margin: 0 auto;
               display: flex;
               .content-icon{
                   padding: 0 10px;
                   text-align: center;
                   width: 259px;
                   .special{
                       height: 60px;
                   }
                   p:nth-child(2){
                       margin-top: 26px;
                        color: #000;
                        font-size: 20px;
                        line-height: 2;
                        font-weight: bold;
                    }
                    p:nth-child(3){
                        color: #000;
                        font-size: 14px;
                        line-height: 1.86;
                    }
               }
           } 
        }
    }
    
}
</style>